import { useNavigate } from "react-router";
import { Copy } from "@/copy/copy";
import type { Family } from "@/generated/core/v1/family";
import type { PDate } from "@/plan-logic/lib/dates";
import { hasRetiredMember } from "@/questionnaire/retirementAge";

/** Where the banner sends a household to check its birthdays and retirement age. */
export const CHECK_AGES_URL = "/app/update-data?open=people";

/**
 * "Abi's support for life after retirement is limited for now" (Ian, 2026-10-31): shown while a
 * member of the household is retired (`hasRetiredMember`), beside the runs-short banner, in the
 * same family (`.shortban`) with an info tone. `fix`: offer the way to Update Data; without it (on
 * Update Data itself) the text points to the form below instead.
 */
export function RetiredBanner({
  family,
  today,
  fix = true,
}: {
  family: Family;
  today: PDate;
  fix?: boolean;
}) {
  const navigate = useNavigate();
  if (!hasRetiredMember(family, today)) return null;
  return (
    <div className="shortban info" role="status" data-testid="retired-banner">
      <span className="bi" aria-hidden="true">
        i
      </span>
      <div>
        <Copy k="plan.retiredTitle" as="b" />
        <Copy k={fix ? "plan.retiredBody" : "plan.retiredBodyHere"} as="p" />
      </div>
      {fix && (
        <button type="button" className="go" onClick={() => navigate(CHECK_AGES_URL)}>
          <Copy k="plan.retiredFix" />
        </button>
      )}
    </div>
  );
}
